export default __webpack_public_path__ + "static/waa_logo-2ff8825a0cc487719efa0010d30c48e8.svg";